import React from 'react';
import { SlidePage } from '../index';
import { BodyContainer, ProgressBox, ProgressStat } from '../styles';
import { dimColors } from '../constants';

// const getColor = value => {
//   if (value < 40) {
//     return polarColors[0];
//   }
//   return polarColors[4];
// };

const DecisionMakingSecondPage = ({ user, background, number }) => {
  // const { TOP_DECISION_STYLE } = user;

  const busquedaApoyo = parseFloat(user['Búsqueda de Apoyo']);

  return (
    <SlidePage number={number} background={background}>
      <BodyContainer>
        <div className='content'>
          <h3>Búsqueda de Apoyo</h3>
          <p className='justified'>
            Aquellos que muestran una alta puntuación en esta escala suelen{' '}
            <strong>
              implementar estrategias que se orientan a la búsqueda de
              asesoramiento y/o respaldo de terceros
            </strong>{' '}
            durante el proceso de toma de decisiones. Esto puede traducirse en
            prácticas como consultar a otras personas para obtener orientaciones
            y sugerencias sobre cómo deberían afrontar la decisión; o buscar
            soporte emocional para manejar las inquietudes que surgen durante
            este proceso. En algunos casos, pueden preferir que otras personas
            tomen la decisión por ellos o busquen soluciones que permitan
            agilizar el proceso de toma de decisiones.
          </p>
          <p className='justified'>
            Por ejemplo, se puede optar por consultar a padres, profesores/as,
            orientadores/as o profesionales del campo de interés para obtener un
            mejor entendimiento de la carrera, o incluso para aliviar sus
            preocupaciones relacionadas con la elección de la carrera. La
            búsqueda de apoyo en otros es un método eficaz para manejar el
            estrés y las dificultades inherentes a la elección de una carrera
            profesional.{' '}
            <strong>
              Sin embargo, es importante que no sea la estrategia predominante,
              sino que se acompañe de estrategias de afrontamiento productivo,
              que te ayuden a tomar tu decisión personalmente
            </strong>
            .
          </p>
          {/* <div className='paragraph'>¿Cómo potenciar y trabajar este estilo?</div>
          <ul className='text-list'>
            <li>-	Establecimiento de metas a corto y largo plazo</li>
            <li>-	Planificación de carrera</li>
            <li>-	Promover la investigación activa</li>
          </ul> */}
          <div className='progress-info-group'>
            <div className='progress-info'>
              <div className='progress-details-single'>
                <div className='progress-name'>Búsqueda de Apoyo</div>
                <ProgressBox
                  progress={busquedaApoyo}
                  backColor={() => dimColors[2]}
                >
                  <div className='progress'></div>
                </ProgressBox>
                <ProgressStat>{busquedaApoyo}</ProgressStat>
              </div>
            </div>
          </div>
          <br />
        </div>
      </BodyContainer>
    </SlidePage>
  );
};

export default DecisionMakingSecondPage;
